
<mat-form-field>
  <mat-label>Select Sensors</mat-label>
  <mat-select [(ngModel)]="sensorIds" multiple #sensorSelect="ngModel">
    <mat-select-trigger>
      {{title}}
    </mat-select-trigger>
    @for (s of sensors; track s) {
      <mat-option [value]="s.id">{{s.name}}</mat-option>
    }
  </mat-select>
  @if (loading) {
    <mat-spinner matSuffix diameter=25 strokeWidth=4></mat-spinner>
  }
</mat-form-field>

@if (displayList) {
  <div class="row">
    <div class="col-12">
      <h5>Selected Sensors:</h5>
      <ul class="list">
        @for (sensor of selectedSensors; track sensor) {
          <li>
            {{sensor.name}}
          </li>
        }
      </ul>
    </div>
  </div>
}